import { darken, makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: 6,
    backgroundColor: theme.palette.primary.light,
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8
  },
  icon: { fontSize: 18, marginRight: 4 },
  iconWarning: { fontSize: 16, marginRight: 4 },
  text: { color: theme.palette.primary.main, fontWeight: 600 },
  verticalAlign: {
    display: 'flex',
    verticalAlign: 'middle',
    color: theme.palette.primary.main,
    fontWeight: 500,
    lineHeight: '20px'
    // alignSelf: 'center'
  },
  warning: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1),
    background:
      theme.palette.type === 'dark'
        ? darken(theme.palette.warning.light, 0.8)
        : '#FFF8E1',

    gap: 4,
    border: `1px solid ${theme.palette.warning.main}`,
    borderRadius: 8,
    margin: '8px 0 8px 0'
  },
  warningText: { fontWeight: 500, color: theme.palette.text.primary },
  verticalAlignWarning: {
    display: 'flex',
    verticalAlign: 'middle',
    color: theme.palette.warning.main,
    fontSize: 14,
    fontWeight: 500
  },
  timeText: { color: theme.palette.primary.main, fontWeight: 600 }
}))
